import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bc6c0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-top" }
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_w",
  src: "/assets/icon/btn_back_w.png",
  srcset: "/assets/icon/btn_back_w@2x.png 2x,/assets/icon/btn_back_w@3x.png 3x"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_7 = { class: "chat-container" }
const _hoisted_8 = { class: "date_wrap" }
const _hoisted_9 = { class: "date-badge" }
const _hoisted_10 = { class: "footer_container space-between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 다른 조건으로 제안 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 이 조건에 팔기 ", -1))
const _hoisted_13 = { class: "footer_container space-between" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 협의 취소 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 조건 수정 ", -1))
const _hoisted_16 = { class: "footer_container space-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 나가기 ", -1))
const _hoisted_18 = { class: "footer_container space-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 협의 취소 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_sell_message = _resolveComponent("sell-message")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "ionContent",
        fullscreen: true,
        "scroll-events": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent btn-back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':`뒤로가기`});_ctx.closeModal();})
                }, [
                  _hoisted_4,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.LeadNickname), 1)
              ]),
              _hoisted_5
            ])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageMap.keys(), (key, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "days-chat"
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.printDate(key)), 1)
                ], 512), [
                  [_vShow, idx !== 0]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageMap.get(key), (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m,
                    class: "message-content"
                  }, [
                    _createVNode(_component_sell_message, {
                      "child-message": m,
                      "user-id": _ctx.userId
                    }, null, 8, ["child-message", "user-id"])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, {
        class: "ion-no-border",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent khaki_btn footer_btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`다른 조건으로 제안`});_ctx.suggestToLeadAngel('suggestToLeadAngel')})
              }, [
                _hoisted_11,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent green_btn footer_btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`이 조건에 팔기`});_ctx.createModal('approveToLeadAngel')})
              }, [
                _hoisted_12,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ])
          ], 512), [
            [_vShow, _ctx.channelStatus === 'suggestToSeller' || _ctx.channelStatus === 'reSuggestToSeller']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent khaki_btn footer_btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`협의 취소`});_ctx.cancelToLeadAngel()})
              }, [
                _hoisted_14,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent green_btn footer_btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`조건 수정`});_ctx.suggestToLeadAngel('reSuggestToLeadAngel')})
              }, [
                _hoisted_15,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ])
          ], 512), [
            [_vShow, _ctx.channelStatus === 'suggestToLeadAngel' || _ctx.channelStatus === 'reSuggestToLeadAngel']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent khaki_btn footer_btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`나가기`});_ctx.closeModal()})
              }, [
                _hoisted_17,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ])
          ], 512), [
            [_vShow, _ctx.channelStatus === 'cancelToSeller' || _ctx.channelStatus === 'cancelToLeadAngel' || _ctx.channelStatus === 'complete' || _ctx.channelStatus === 'depositDelayCancel']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent khaki_btn footer_btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`협의 취소`});_ctx.cancelToLeadAngel()})
              }, [
                _hoisted_19,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ])
          ], 512), [
            [_vShow, _ctx.channelStatus === 'approveToSeller' || _ctx.channelStatus === 'approveToLeadAngel']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}